module.exports = __webpack_public_path__ + "img/3.a1c0c72d.jpg";